<template>
  <div class="container">
    <div class="restaurant">
      <div class="nav-container">
        <div class="d-flex align-center">
          <router-link to="/RestaurantRoot">
            <img src="../assets/img/arrowBack.svg" class="img-pluss-btn" alt="arrow-back" />
          </router-link>

          <h1 class="page-title">Добавление ресторана</h1>
        </div>
        <div>
          <button @click="createRestbtn" class="btn-create" style="gap: 5px;">Cоздать <svg width="15" height="11"
              viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9323 1.25L5.22396 9.95833L1.26562 6" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg></button>
        </div>

      </div>
      <div class="">
        <div class="content-container">
          <div class="box-container">
            <h2 class="information-title">Информация</h2>

            <div class="horizontal-line"></div>

            <div class="col-content rest-name-container">
              <p class="col-title">Название ресторана <span class="red-dot">*</span></p>
              <input class="input-css" v-model="name" placeholder="---">
            </div>


            <div class="col-content desc-rest-container">
              <p class="col-title">Описание ресторана <span class="red-dot">*</span></p>
              <textarea class="input-css-textarea" v-model="description" placeholder="---"></textarea>
            </div>

            <div class="search-component">
              <p class="col-title">Юридическое лицо <span class="red-dot">*</span></p>
              <v-autocomplete v-model="accountId" placeholder="---" :items="accounts" item-text="name" item-value="id"
                hide-details solo id="restaurant-selector" class="input-css">
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { 'active': isSelected }]">
                    {{ item.name }}
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div class="col-content phonenumber-container">
              <p class="col-title"> Номер телефона для связи клиентов <span class="red-dot">*</span></p>
              <input class="input-css" @input="formatPhone" v-model="phoneNumber" placeholder="+7("
                v-mask="'+7 (###) ###-##-##'">
            </div>

            <div class="search-component">
              <p class="col-title">Выбор приложения <span class="red-dot">*</span></p>
              <v-autocomplete v-model="applicationId" placeholder="---" :items="applications" item-text="name"
                item-value="id" hide-details solo id="application-selector" class="input-css">
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { 'active': isSelected }]">
                    {{ item.name }}
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div class="search-component">
              <p class="col-title">Город <span class="red-dot">*</span></p>
              <v-autocomplete 
                v-model="cityId" 
                placeholder="---" 
                :items="cities" 
                item-text="name" 
                item-value="id"
                hide-details 
                solo 
                id="city-selector" 
                class="input-css">
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { 'active': isSelected }]">
                    {{ item.name }}
                  </div>
                </template>
              </v-autocomplete>
            </div>
            <div class="col-content adress-container">
              <p class="col-title">Адрес <span class="red-dot">*</span></p>
              <input class="input-css" v-model="address" placeholder="---" />
            </div>

            <div class="col-content minorder-container">
              <p class="col-title">Минимальная сумма заказа <span class="red-dot">*</span></p>
              <input type="number" class="input-css" v-model="minOrderAmount" placeholder="---" />
            </div>

            <div class="deliverty-title-margin">
              <p class="delivery-title">Доставка</p>
            </div>
            <div class="d-flex align-center justify-space-between">
              <p class="delivery-text">{{
                isUsingDelivery ? "Используется" : "Не используется"
              }}</p>
              <div class="">
                <input type="checkbox" hidden="hidden" id="discount" v-model="isUsingDelivery" />
                <label class="switch" for="discount"></label>
              </div>
            </div>

            <div class="loyal-margin">
              <p class="delivery-title">Лояльность</p>
            </div>
            <div class="d-flex align-center justify-space-between">
              <p class="delivery-text">{{
                isUsingBonus ? "Используется" : "Не используется"
              }}</p>
              <div class="">
                <input type="checkbox" hidden="hidden" id="bonus" v-model="isUsingBonus" />
                <label class="switch" for="bonus"></label>
              </div>
            </div>
            <div v-if="isUsingBonus" class="search-component">
                <p class="col-title">Бонусная группа</p>
                <v-autocomplete
                  v-model="restaurantBonusGroupId"
                  placeholder="---"
                  :items="bonusGroups"
                  item-text="name"
                  item-value="id"
                  hide-details
                  solo
                  class="input-css"
                  :disabled="!accountId"
                >
                  <template v-slot:item="{ item, isSelected }">
                    <div :class="['restaurant-item', { 'active': isSelected }]">
                      {{ item.name }}
                    </div>
                  </template>
                </v-autocomplete>
              </div>
            <div class="col-content rest-name-container">
              <p class="col-title">Широта <span class="red-dot">*</span></p>
              <input type="number" class="input-css" v-model="latitude" placeholder="---">
            </div>
            <div class="col-content rest-name-container">
              <p class="col-title">Долгота <span class="red-dot">*</span></p>
              <input type="number" class="input-css" v-model="longitude" placeholder="---">
            </div>
            <div class="col-content rest-name-container mb-4">
                  <p class="col-title">Дата запуска<span class="red-dot">*</span></p>
                  
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div 
                        class="input-css custom-date-input" 
                        v-bind="attrs" 
                        v-on="on"
                      >
                        <span :class="{'placeholder-text': !resReleaseDate}">
                          {{ resReleaseDate ? formatDisplayDate(resReleaseDate) : '---' }}
                        </span>
                        <v-icon сlass="mt-0">mdi-calendar</v-icon>
                      </div>
                    </template>

                    <v-date-picker
                      v-model="resReleaseDate"
                      @input="dateMenu = false"
                      color="#323C4D"
                      locale="ru-ru"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </div>
          </div>
        </div>

      </div>
      <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
        {{ message }}
        <template v-slot:action="{ attrs }">
          <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
            Закрыть
          </div>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>


<style scoped>
.custom-date-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  background-color: #fff;
  /* Добавьте padding, если в вашем .input-css его нет */
  padding: 0 12px; 
}
input[type="number"] {
  -moz-appearance: textfield;
  /* Убирает стрелочки в Firefox */
  -webkit-appearance: none;
  /* Убирает стрелочки в Chrome, Safari */
  appearance: none;
  /* Для совместимости */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  /* Убирает стрелочки в Chrome, Safari */
  margin: 0;
  /* Убирает лишние отступы */
}

.snackbar-btn {
  color: var(--Red, #eb5757);
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1.25rem;
  margin-right: auto;
  padding: 14px 16px;
  text-align: initial;
  cursor: pointer;
}

.restaurant-item {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.restaurant-item :first-child {
  /* padding-left: 10px; */
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.deliverty-title-margin {
  margin-top: 29.5px;
}

.loyal-margin {
  margin-top: 29.5px;
}

.delivery-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 15px;
  color: #606c80;
  margin-bottom: 0px;
}

.delivery-title {
  margin-bottom: 0px;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;
}

.switch {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 25px;
  border-radius: 20px;
  background: #eaeaea;
  transition: background 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  cursor: pointer;
}

.switch::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #fafafa;
  border-radius: 50%;
  transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(128, 128, 128, 0.1);
}

input:checked+.switch {
  background: #72da67;
}

input:checked+.switch::before {
  left: 27px;
  background: #fff;
}

input:checked+.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(0, 150, 136, 0.2);
}

.minorder-container {
  margin-top: 23.5px;
}

.search-component {
  margin-top: 11.5px;
}

.adress-container {
  margin-top: 23.5px;
}

.phonenumber-container {
  margin-top: 23.5px;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
  border: 1px solid transparent !important;
}

.desc-rest-container {
  margin-top: 14px;
}

.rest-name-container {
  margin-top: 17px;
}

.input-css {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  /* height: 42px; */
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;

}

.input-css-textarea {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  height: 72px;
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;
  resize: none;
}

.input-css-textarea:hover,
.input-css-textarea:focus {
  border: 1px solid #d4d4e1;
  /* Цвет бордера при наведении */
}

.input-css:hover,
.input-css:focus {
  border: 1px solid #d4d4e1;
  /* Цвет бордера при наведении */
}

.box-container {
  padding: 18px 18px;
}

.btn-create {
  width: 121px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 18px;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  color: white;

}

.page-title {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  color: #323c4d;
}

.work-margin-bot {
  margin-bottom: 50px;
}

.col-title-work {
  color: var(--Gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 0px;
}


.special-border:focus {
  border-radius: 3px;
  border: 2px solid var(--03, black);
  background: var(--white, #fff);
  width: 295px;
  height: 37px;
  padding-left: 10px;
}

.special-border {
  border-radius: 3px;
  border: 1px solid var(--03, #c1c1c1);
  background: var(--white, #fff);
  width: 295px;
  height: 37px;
  padding-left: 10px;
}

.time-end {
  color: var(--Gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 146.667% */
}

.time-start {
  color: var(--Gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 146.667% */
}

.end-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.start-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 21px;
}

.work-img-margin {
  margin-right: 21px;
}

.work-1 {
  text-align: end;
}

.dot-work {
  margin-left: 69px;
}

.work-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-container {
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 17px;
}

.img-pluss-btn {
  cursor: pointer;
  height: 100%;
  display: flex;
  margin-right: 17px;
}

.nav-container {
  /* border-right: 1px solid var(--04, #eaeaea); */
  /* width: 56px; */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* .top-panel .container {
    width: 100%;
    padding: 0px !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
  } */
.vertical-line {
  width: 1px;
  height: 42px;
  background: #e0e0e0;
  margin-left: 31px;
}

.vertical-line-1 {
  width: 1px;
  height: 50px;
  background: #e0e0e0;
}

.add-btn .add-text {
  color: var(--01, #333);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  margin-left: 12px;
  transition: color 0.3s ease;
}

.add-btn:hover .add-text {
  /* Цвет текста при наведении */
  color: black;
  /* Замените "red" на желаемый цвет текста */
  font-weight: 500;
  font-size: 17px;
}

.add-btn {
  display: flex;
  align-items: center;
  padding: 12px 0px;
  margin-left: 37px;
  cursor: pointer;
}

.top-panel {
  border-bottom: 1px solid var(--04, #eaeaea);
  background: var(--white, #fff);
  height: 50px;
  display: flex;
  align-items: center;
}






.requisites-text-container {
  display: flex !important;
  flex-direction: row;
  /* justify-content: space-evenly; */
  align-items: baseline;
}

.requisites-title {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 227px;
}

.margin-logo-divider {
  margin-bottom: 48px;
}

.logo-dot-3 {
  margin-right: 13px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.logo-dot-2 {
  margin-right: 16px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.logo-dot {
  margin-right: 69px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.custom-file-upload {
  cursor: pointer;
}

.logo-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.uploaded-image-logo {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.uploaded-image-header {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.uploaded-image-photo-rest {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.work-margin-img {
  margin-bottom: 15px;
}

.work-img {
  width: 22px;
  height: 22px;
}

.col-img {
  flex-direction: column-reverse;
  display: flex;
}

.work-margin {
  padding-bottom: 15px;
}

.horizontal-line {
  height: 1px;
  background: #d4d4e1;
  margin-top: 5px;

}

.tel-pointer {
  cursor: pointer;
}

.col-paddings-r-l {
  padding-right: 0px;
  padding-left: 0px;
}

.col-paddings-t-b {
  padding-top: 0px;
  padding-bottom: 0px;
}

.col-content {
  display: flex;
  flex-direction: column;
}



.red-dot {
  color: #e41313;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.col-title {
  color: #323c4d;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.information-title {
  font-family: Inter;
  font-style: normal;
  line-height: normal;
  font-weight: 700;
  font-size: 20px;
  color: #323c4d;
}

.content-container {
  border-radius: 8px;
  background: var(--white, #fff);
  margin-top: 16px;
  width: 100%;
  max-width: 533px;
}

@media (max-width: 1069px) {
  .page-title {
    font-family: Inter;
    font-weight: 700;
    font-size: 19px;
    color: #323c4d;
    line-height: normal;
  }

  .nav-container {
    margin-top: 24px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
export default {
  name: "CreateNewRest",
  directives: { mask },
  props: {
    requestData: {},
    responseData: {},
  },
  data() {
    return {
      snackbar: false,
      message: "",
      selectedImage: null,
      uploadedImageLogo: "",
      uploadedImageHeader: "",
      uploadedImagePhotoRest: "",
      minOrder: "",
      commisionFromOrder: "",
      name: "",
      latitude: "",
      longitude: "",
      orderRestinApp: "",
      minOrderAmount: "",
      description: "",
      address: "",
      phoneNumber: "",
      instagram: "",
      isUsingDelivery: true,
      isUsingBonus: true,
      accountId: "",
      applicationId: "",
      newRest: {
      },
      currentAcc: "",
      accounts: [],
      applications: [],
      bonusGroups: [],
      cityId: null,
      cities: [],
      restaurantBonusGroupId: "",
      currentPage: 0,
      totalPages: 0,
      totalItems: 0,
      dateMenu: false,
      resReleaseDate: '',
    };
  },

  methods: {
    validateInput() {
      // --- для minOrderAmount ---
      this.minOrderAmount = this.minOrderAmount.replace(/\D/g, "");
      if (this.minOrderAmount) {
        this.minOrderAmount = Number(this.minOrderAmount).toLocaleString("ru-RU");
      }

      // --- для latitude ---
      if (this.latitude !== undefined && this.latitude !== null) {
        let lat = this.latitude.toString().replace(/[^0-9.]/g, "");
        const latParts = lat.split(".");
        if (latParts.length > 2) {
          lat = latParts[0] + "." + latParts.slice(1).join("");
        }
        this.latitude = lat ? Number(lat) : null;  // <-- число
      }

      // --- для longitude ---
      if (this.longitude !== undefined && this.longitude !== null) {
        let lng = this.longitude.toString().replace(/[^0-9.]/g, "");
        const lngParts = lng.split(".");
        if (lngParts.length > 2) {
          lng = lngParts[0] + "." + lngParts.slice(1).join("");
        }
        this.longitude = lng ? Number(lng) : null; // <-- число
      }
    },
    formatPhone() {
      if (this.phoneNumber === "7") {
        this.phoneNumber = "+7 (7"; // Автоматически добавляем второй 7
      }
    },
    async fetchCities() {
      try {
        // Предполагается, что вы используете axios или $http
        const response = await this.$http.get('/api/City'); 
        
        // В зависимости от структуры ответа бэкенда, присваиваем массив:
        // Если ответ сразу массив: this.cities = response.data;
        // Если ответ лежит внутри объекта: this.cities = response.data.items;
        this.cities = response.data; 
      } catch (error) {
        console.error('Ошибка при загрузке списка городов:', error);
        // Можно показать ваш снекбар с ошибкой
        this.message = 'Не удалось загрузить список городов';
        this.snackbar = true;
      }
    },
    uploadImageLogo(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageLogo = URL.createObjectURL(file);
      }
    },
    uploadImageHeader(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageHeader = URL.createObjectURL(file);
      }
    },
    uploadImagePhotoRest(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImagePhotoRest = URL.createObjectURL(file);
      }
    },
    createRestbtn() {
      this.createNewRest();
    },

    createNewRest() {
      this.newRest.name = this.name || null;
      this.newRest.latitude = this.latitude || null;
      this.newRest.longitude = this.longitude || null;
      this.newRest.description = this.description || null;
      this.newRest.accountId = this.accountId || null;
      this.newRest.phoneNumber = this.phoneNumber || null;
      this.newRest.applicationId = this.applicationId || null;
      this.newRest.cityId = this.cityId || null;
      this.newRest.address = this.address || null;
      this.newRest.minOrderAmount = this.minOrderAmount || null;
      this.newRest.isUsingDelivery = this.isUsingDelivery;
      this.newRest.isUsingBonus = this.isUsingBonus;
      this.newRest.restaurantBonusGroupId = this.restaurantBonusGroupId || null;
      this.newRest.releaseDate = this.resReleaseDate || new Date().toISOString();
      if (!this.name || this.name.trim() === '') {
        this.snackbar = true;
        this.message = "Название ресторана обязательно для заполнения";
        return;
      }
      if (!this.latitude || this.latitude.trim() === '') {
        this.snackbar = true;
        this.message = "Ширина ресторана обязательно для заполнения";
        return;
      }
      if (!this.longitude || this.longitude.trim() === '') {
        this.snackbar = true;
        this.message = "Долгота ресторана обязательна для заполнения";
        return;
      }
      if (!this.description || this.description.trim() === '') {
        this.snackbar = true;
        this.message = "Описание ресторана обязательно для заполнения";
        return;
      }
      if (!this.address || this.address.trim() === '') {
        this.snackbar = true;
        this.message = "Адрес ресторана обязателен для заполнения";
        return;
      }
      if (!this.minOrderAmount || this.minOrderAmount === '') {
        this.snackbar = true;
        this.message = "Минимальная сумма заказа обязательна для заполнения";
        return;
      }
      if (!this.phoneNumber || this.phoneNumber.trim() === '') {
        this.snackbar = true;
        this.message = "Номер телефона для связи клиентов обязателен для заполнения";
        return;
      }
      if (!this.accountId || this.accountId === null) {
        this.snackbar = true;
        this.message = "Юр лицо обязателен для заполнения";
        return;
      }
      if (!this.cityId || this.cityId === null) {
        this.message = 'Пожалуйста, выберите город';
        this.snackbar = true;
        return;
      }
      if (!this.applicationId || this.applicationId === null) {
        this.snackbar = true;
        this.message = "Приложение обязателено для заполнения";
        return;
      }
      this.$http
        .post("/api/Restaurant", this.newRest)
        .then(() => {
          // this.$router.push({ path: `/RestaurantRoot/` });
          // this.initialize();
          // this.dialogCreate = false;
          // this.newAcc = {
          //   name: "",
          //   bin: "",
          //   bic: "",
          //   legalAddress: ""
          // };
          this.snackbar = true;
          this.message = "Ресторан успешно создан"
          setTimeout(() => {
            this.$router.push({ path: `/RestaurantRoot/` });
          }, 3000);
        })
        .catch((error) => {
          //alert(error);
          this.snackbar = true;
          if (error.response && error.response.status === 400) {
            this.message = "Заполните данные";
          } else {
            this.message = "Не удалось создать ресторан";
          }
        });
    },
    accountList() {
      this.$http
        .put("/api/Account/PagedList", {
          pageNumber: 1,
          pageSize: -1,
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          // Предполагается, что `response.data.items` содержит массив объектов
          this.accounts = response.data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            name: item.name || "Не указано", // Название аккаунта

          }));

          // Устанавливаем общее количество элементов и проверяем наличие данных
          this.totalItems = response.data.totalCount;
          this.showNoDataMessage = this.totalItems === 0;
        })
        .catch((error) => {
          this.error = error;
        });
    },
      formatDisplayDate(date) {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}.${month}.${year}`;
  },
    appList() {
      this.$http
        .put("/api/Application/PagedList", {
          pageNumber: 1,
          pageSize: -1,
          headers: {
            'Content-Type': 'application/json',
          },
          //             filters: [
          //   {
          //     property: "Name",
          //     operator: "contains",
          //     value: this.search.toLowerCase(),
          //   }
          // ],
        })
        .then((response) => {
          this.applications = response.data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            name: item.brandName || "Не указано", // Название аккаунта

          }));
          //this.totalPages = response.data.totalPages; // Общее количество страниц
          this.totalItems = response.data.totalCount;
          this.showNoDataMessage = this.totalItems === 0;
        })
        .catch((error) => {
          this.error = error;
        });
    },
    loadBonusGroups() {
    this.$http
      .put("/api/RestaurantBonusGroup/PagedList", {
          pageNumber: 1,
          pageSize: -1,
          headers: {
            'Content-Type': 'application/json',
          },
          filters: [
            {
              property: "accountId",
              operator: "eq",
              value: this.accountId,
            }
          ],
        })
      .then(({ data }) => {
        // this.bonusGroups = data.items || [];
        this.bonusGroups = data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            name: item.name || "Не указано", // Название аккаунта
          }));
      })
      .catch(() => {
        this.snackbar = true;
        this.message = "Ошибка загрузки бонусных групп";
      });
  }


  },
  created() {
    this.accountList();
    this.appList();
    this.fetchCities();
    // this.loadBonusGroups();
  },

  watch: {
    accountId(newVal) {
      if (newVal) {
        // когда пользователь выбрал accountId — грузим бонусные группы
        this.loadBonusGroups(newVal);
      } else {
        // если очистил выбор — блокируем поле и очищаем список
        this.bonusGroups = [];
        this.restaurantBonusGroupId = null;
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
};
</script>





<style lang="scss">
@media (min-width: 1264px) {
  .container {
    //1185px дефолтное название если что то ломаться начнется на маленьких мониторах
    max-width: 100% !important;
  }
}



@media (min-width: 960px) {

  //900 дефолтное название если что то ломаться начнется на маленьких мониторах
  .container {
    max-width: 100% !important;
  }
}
</style>